export default __webpack_public_path__ + "static/media/balsamic.921c3a16.jpg";